import { render, staticRenderFns } from "./serviceItem.vue?vue&type=template&id=4c2e0c5a"
import script from "./serviceItem.vue?vue&type=script&lang=js"
export * from "./serviceItem.vue?vue&type=script&lang=js"
import style0 from "./serviceItem.vue?vue&type=style&index=0&id=4c2e0c5a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports